const https = require('https')
const http = require('http')

module.exports = function (req, res) {
  // Lấy path từ query: /api/pdf-proxy?path=upload/radiology/...
  const urlParams = new URL(req.url, 'http://localhost')
  const pdfPath = urlParams.searchParams.get('path')

  if (!pdfPath) {
    res.statusCode = 400
    return res.end('Missing path')
  }

  const targetUrl = 'https://his.tmhsg.com/' + pdfPath

  https
    .get(targetUrl, (pdfRes) => {
      res.setHeader('Content-Type', 'application/pdf')
      res.setHeader('Access-Control-Allow-Origin', '*')
      res.statusCode = 200
      pdfRes.pipe(res)
    })
    .on('error', (err) => {
      console.error('PDF proxy error:', err)
      res.statusCode = 500
      res.end('Error fetching PDF')
    })
}
